import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase, Typography } from '@mui/material';

// project imports
import config from 'config';
import Logo from 'assets/images/kpkLogo.png';
import SeedLogo from 'assets/images/SeedLogo.png';
import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = (props) => {
  const { right } = props;
  const theme = useTheme();
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase
      disableRipple
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
      component={Link}
      to={'/dashboard/default'}
    >
      {!right ? (
        <Box display={'flex'} gap={3} alignItems={'center'}>
          <img src={Logo} width={40} height={40} />
          <Typography
            color={theme.palette.secondary.main}
            gutterBottom
            variant={'p'}
            fontWeight={600}
            alignSelf={'end'}
          >
            Khyber Pakhtunkhwa Climate Change, Forestry, Environment & Wildlife
            Department
          </Typography>
        </Box>
      ) : (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <img src={SeedLogo} width={150} />
        </Box>
      )}
    </ButtonBase>
  );
};

export default LogoSection;
